export const PUBLIC_KNOWLEDGE_BASE_URL = 'https://partnersupport.plume.com/hc/en-us'
export const CUSTOMER_SUCCESS_JIRA =
  'https://plumedesign.atlassian.net/servicedesk/customer/portal/24/group/56/create/249'

export const SALESFORCE_SAML_KNOWLEDGE_BASE_URL = `${process.env.PORTAL_API_BASE_URL}/misc/salesforce-digital-experience-sso/knowledge-base`
export const SALESFORCE_SAML_RELEASE_NOTES_URL = `${process.env.PORTAL_API_BASE_URL}/misc/salesforce-digital-experience-sso/release-notes`
export const SALESFORCE_SAML_API_DOCUMENTATION_URL = `${process.env.PORTAL_API_BASE_URL}/misc/salesforce-digital-experience-sso/api-documentation`
export const PLUME_SUPPORT_ESCALATION_PROCEDURE = `${process.env.PORTAL_API_BASE_URL}/misc/salesforce-digital-experience-sso/escalation`
